/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../connect/v2/resources/address';
import '../../connect/v2/common/money';
import '../../cash/grantly/api/action';
import '../../connect/v2/resources/error';
import '../../employeejobs/data';
import '../../person/service';
import '../../roster/mds';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "team_api": {
        "nested": {
          "TeamMember": {
            "fields": {
              "id": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "personId": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "referenceId": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "isOwner": {
                "type": "bool",
                "id": 4,
                "rule": "optional"
              },
              "status": {
                "type": ".squareup.team_api.TeamMember.Status",
                "id": 5,
                "rule": "optional"
              },
              "givenName": {
                "type": "string",
                "id": 6,
                "rule": "optional"
              },
              "familyName": {
                "type": "string",
                "id": 7,
                "rule": "optional"
              },
              "emailAddress": {
                "type": "string",
                "id": 8,
                "rule": "optional"
              },
              "phoneNumber": {
                "type": "string",
                "id": 9,
                "rule": "optional"
              },
              "createdAt": {
                "type": "string",
                "id": 10,
                "rule": "optional"
              },
              "updatedAt": {
                "type": "string",
                "id": 11,
                "rule": "optional"
              },
              "assignedLocations": {
                "type": ".squareup.team_api.TeamMember.AssignedLocations",
                "id": 13,
                "rule": "optional"
              },
              "permissionSetId": {
                "type": "string",
                "id": 14,
                "rule": "optional"
              },
              "isAuthorizedRepresentative": {
                "type": "bool",
                "id": 15,
                "rule": "optional"
              },
              "badgePairing": {
                "type": ".squareup.team_api.TeamMemberBadgePairing",
                "id": 16,
                "rule": "optional"
              },
              "invitationStatus": {
                "type": ".squareup.team_api.TeamMember.InvitationStatus",
                "id": 17,
                "rule": "optional"
              },
              "hasPasscode": {
                "type": "bool",
                "id": 18,
                "rule": "optional"
              },
              "canBeManaged": {
                "type": "bool",
                "id": 19,
                "rule": "optional"
              },
              "initials": {
                "type": "string",
                "id": 20,
                "rule": "optional"
              },
              "jobTemplateIds": {
                "type": "string",
                "id": 21,
                "rule": "repeated"
              },
              "merchantId": {
                "type": "string",
                "id": 22,
                "rule": "optional"
              },
              "accessBlockers": {
                "type": ".squareup.team_api.TeamMember.AccessBlocker",
                "id": 23,
                "rule": "repeated"
              },
              "jobIds": {
                "type": "string",
                "id": 24,
                "rule": "repeated"
              },
              "associatedProducts": {
                "type": ".squareup.team_api.TeamMember.AssociatedProducts",
                "id": 25,
                "rule": "optional"
              },
              "inviteEligibilityStatus": {
                "type": ".squareup.team_api.TeamMember.InviteEligibilityStatus",
                "id": 26,
                "rule": "optional"
              },
              "birthDate": {
                "type": "string",
                "id": 27,
                "rule": "optional"
              },
              "address": {
                "type": ".squareup.connect.v2.resources.Address",
                "id": 28,
                "rule": "optional"
              },
              "complianceRequiredFields": {
                "type": "string",
                "id": 29,
                "rule": "repeated"
              },
              "wageSetting": {
                "type": ".squareup.team_api.WageSetting",
                "id": 30,
                "rule": "optional"
              }
            },
            "nested": {
              "InviteEligibilityStatus": {
                "values": {
                  "INVITE_ELIGIBILITY_STATUS_DO_NOT_USE": 0,
                  "ELIGIBLE": 1,
                  "INELIGIBLE": 2
                }
              },
              "InvitationStatus": {
                "values": {
                  "INVITATION_STATUS_DO_NOT_USE": 0,
                  "UNINVITED": 1,
                  "PENDING": 2,
                  "ACCEPTED": 3,
                  "DECLINED": 4,
                  "EXPIRED": 5
                }
              },
              "Status": {
                "values": {
                  "STATUS_DO_NOT_USE": 0,
                  "ACTIVE": 1,
                  "INACTIVE": 2
                }
              },
              "AccessBlocker": {
                "values": {
                  "ACCESS_BLOCKER_DO_NOT_USE": 0,
                  "EMPLOYEE_MANAGEMENT_SUBSCRIPTION": 1,
                  "EMPLOYEE_MANAGEMENT_SUBSCRIPTION_PAUSED": 2
                }
              },
              "AssignedLocations": {
                "fields": {
                  "assignmentType": {
                    "type": ".squareup.team_api.TeamMember.AssignedLocations.AssignmentType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "locationIds": {
                    "type": "string",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "authorizedLocationIds": {
                    "type": "string",
                    "id": 3,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "AssignmentType": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "ALL_CURRENT_AND_FUTURE_LOCATIONS": 1,
                      "EXPLICIT_LOCATIONS": 2
                    }
                  }
                }
              },
              "AssociatedProducts": {
                "fields": {
                  "payroll": {
                    "type": ".squareup.team_api.TeamMember.AssociatedProducts.AssociatedProduct",
                    "id": 1,
                    "rule": "optional"
                  },
                  "appointments": {
                    "type": ".squareup.team_api.TeamMember.AssociatedProducts.AssociatedProduct",
                    "id": 2,
                    "rule": "optional"
                  },
                  "tipPayouts": {
                    "type": ".squareup.team_api.TeamMember.AssociatedProducts.AssociatedProduct",
                    "id": 3,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "AssociatedProduct": {
                    "fields": {
                      "status": {
                        "type": ".squareup.team_api.TeamMember.AssociatedProducts.AssociatedProduct.AssociatedProductStatus",
                        "id": 1,
                        "rule": "optional"
                      },
                      "createdAt": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "updatedAt": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "AssociatedProductStatus": {
                        "values": {
                          "UNKNOWN": 0,
                          "ADDED_INCOMPLETE": 1,
                          "ADDED": 2,
                          "EMPTY": 3,
                          "REMOVED": 4
                        }
                      }
                    }
                  }
                }
              }
            }
          },
          "TeamMemberFetchFieldScope": {
            "nested": {
              "FetchField": {
                "values": {
                  "DO_NOT_USE": 0,
                  "ACCESS_BLOCKERS": 2,
                  "INITIALS": 3,
                  "HAS_PASSCODE": 4,
                  "JOB_TEMPLATE_IDS": 5,
                  "JOB_IDS": 6,
                  "ASSOCIATED_PRODUCTS": 7,
                  "PERSON_ID": 8,
                  "COMPLIANCE_DATA": 9
                }
              }
            }
          },
          "TeamMemberBadgePairing": {
            "fields": {
              "teamMemberId": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "state": {
                "type": ".squareup.team_api.TeamMemberBadgePairing.State",
                "id": 2,
                "rule": "optional"
              },
              "uuid": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              }
            },
            "nested": {
              "State": {
                "values": {
                  "DO_NOT_USE": 0,
                  "ACTIVE": 1,
                  "INACTIVE": 2
                }
              }
            }
          },
          "Job": {
            "fields": {
              "id": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "title": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "isTipEligible": {
                "type": "bool",
                "id": 3,
                "rule": "optional"
              },
              "createdAt": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              },
              "updatedAt": {
                "type": "string",
                "id": 5,
                "rule": "optional"
              },
              "version": {
                "type": "uint64",
                "id": 6,
                "rule": "optional"
              }
            }
          },
          "WageSetting": {
            "fields": {
              "teamMemberId": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "jobAssignments": {
                "type": ".squareup.team_api.JobAssignment",
                "id": 2,
                "rule": "repeated"
              },
              "isOvertimeExempt": {
                "type": "bool",
                "id": 3,
                "rule": "optional"
              },
              "version": {
                "type": "uint64",
                "id": 4,
                "rule": "optional"
              },
              "createdAt": {
                "type": "string",
                "id": 5,
                "rule": "optional"
              },
              "updatedAt": {
                "type": "string",
                "id": 6,
                "rule": "optional"
              }
            }
          },
          "JobAssignment": {
            "fields": {
              "jobTitle": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "payType": {
                "type": ".squareup.team_api.JobAssignment.PayType",
                "id": 2,
                "rule": "optional"
              },
              "hourlyRate": {
                "type": ".squareup.connect.v2.common.Money",
                "id": 3,
                "rule": "optional"
              },
              "annualRate": {
                "type": ".squareup.connect.v2.common.Money",
                "id": 4,
                "rule": "optional"
              },
              "weeklyHours": {
                "type": "uint32",
                "id": 5,
                "rule": "optional"
              },
              "jobId": {
                "type": "string",
                "id": 6,
                "rule": "optional"
              }
            },
            "nested": {
              "PayType": {
                "values": {
                  "STATUS_DO_NOT_USE": 0,
                  "NONE": 1,
                  "HOURLY": 2,
                  "SALARY": 3
                }
              }
            }
          },
          "ContactMethodType": {
            "values": {
              "CONTACT_METHOD_DO_NOT_USE": 0,
              "EMAIL": 1,
              "PHONE": 2
            }
          },
          "TeamMemberInvitation": {
            "fields": {
              "id": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "teamMemberId": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "merchantId": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "sendCount": {
                "type": "uint32",
                "id": 4,
                "rule": "optional"
              },
              "createdAt": {
                "type": "string",
                "id": 5,
                "rule": "optional"
              },
              "updatedAt": {
                "type": "string",
                "id": 6,
                "rule": "optional"
              },
              "version": {
                "type": "uint32",
                "id": 7,
                "rule": "optional"
              },
              "contactMethodType": {
                "type": ".squareup.team_api.ContactMethodType",
                "id": 8,
                "rule": "optional"
              },
              "contactMethodValue": {
                "type": "string",
                "id": 9,
                "rule": "optional"
              },
              "expiredAt": {
                "type": "string",
                "id": 10,
                "rule": "optional"
              }
            }
          },
          "TeamMemberCashAppAccount": {
            "fields": {
              "teamMemberId": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "actionType": {
                "type": ".squareup.cash.grantly.api.Action.Type",
                "id": 2,
                "rule": "optional"
              },
              "cashGrantId": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "cashCustomerId": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              },
              "cashtag": {
                "type": "string",
                "id": 5,
                "rule": "optional"
              }
            }
          },
          "TeamMemberIncludes": {
            "nested": {
              "Include": {
                "values": {
                  "DO_NOT_USE": 0,
                  "JOBS": 1,
                  "PERSONS": 3,
                  "MERCHANTS": 4,
                  "CASH_APP_ACCOUNTS": 5
                }
              }
            }
          },
          "TeamMemberIncludedResources": {
            "fields": {
              "errors": {
                "type": ".squareup.connect.v2.resources.Error",
                "id": 1,
                "rule": "repeated"
              },
              "jobs": {
                "type": ".squareup.employeejobs.Job",
                "id": 2,
                "rule": "repeated"
              },
              "persons": {
                "type": ".squareup.person.Person",
                "id": 4,
                "rule": "repeated"
              },
              "merchants": {
                "type": ".squareup.roster.mds.Merchant",
                "id": 5,
                "rule": "repeated"
              },
              "cashAppAccounts": {
                "type": ".squareup.team_api.TeamMemberCashAppAccount",
                "id": 6,
                "rule": "repeated"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.team_api?.nested?.TeamMember && !$root.nested?.squareup?.nested?.team_api?.nested?.TeamMember?.nested?.InviteEligibilityStatus && !$root.nested?.squareup?.nested?.team_api?.nested?.TeamMember?.nested?.InvitationStatus && !$root.nested?.squareup?.nested?.team_api?.nested?.TeamMember?.nested?.Status && !$root.nested?.squareup?.nested?.team_api?.nested?.TeamMember?.nested?.AccessBlocker && !$root.nested?.squareup?.nested?.team_api?.nested?.TeamMember?.nested?.AssignedLocations && !$root.nested?.squareup?.nested?.team_api?.nested?.TeamMember?.nested?.AssignedLocations?.nested?.AssignmentType && !$root.nested?.squareup?.nested?.team_api?.nested?.TeamMember?.nested?.AssociatedProducts && !$root.nested?.squareup?.nested?.team_api?.nested?.TeamMember?.nested?.AssociatedProducts?.nested?.AssociatedProduct && !$root.nested?.squareup?.nested?.team_api?.nested?.TeamMember?.nested?.AssociatedProducts?.nested?.AssociatedProduct?.nested?.AssociatedProductStatus && !$root.nested?.squareup?.nested?.team_api?.nested?.TeamMemberFetchFieldScope?.nested?.FetchField && !$root.nested?.squareup?.nested?.team_api?.nested?.TeamMemberBadgePairing && !$root.nested?.squareup?.nested?.team_api?.nested?.TeamMemberBadgePairing?.nested?.State && !$root.nested?.squareup?.nested?.team_api?.nested?.Job && !$root.nested?.squareup?.nested?.team_api?.nested?.WageSetting && !$root.nested?.squareup?.nested?.team_api?.nested?.JobAssignment && !$root.nested?.squareup?.nested?.team_api?.nested?.JobAssignment?.nested?.PayType && !$root.nested?.squareup?.nested?.team_api?.nested?.ContactMethodType && !$root.nested?.squareup?.nested?.team_api?.nested?.TeamMemberInvitation && !$root.nested?.squareup?.nested?.team_api?.nested?.TeamMemberCashAppAccount && !$root.nested?.squareup?.nested?.team_api?.nested?.TeamMemberIncludes?.nested?.Include && !$root.nested?.squareup?.nested?.team_api?.nested?.TeamMemberIncludedResources) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc A record representing an individual team member for a business.
 * --
 *
 * SOURCE TeamMember @ squareup/team_api/resources/datatypes.proto at 61:1
 */
export const TeamMember = $root.lookupType('squareup.team_api.TeamMember');
fixType(TeamMember);
Builder.createAndAttachToType(TeamMember);
/**
 * --
 * @desc Enumerates the possible invite eligibility statuses the team member can have within a business.
 * --
 *
 * SOURCE InviteEligibilityStatus @ squareup/team_api/resources/datatypes.proto at 343:3
 */
TeamMember.InviteEligibilityStatus = $root.lookupEnum('squareup.team_api.TeamMember.InviteEligibilityStatus').values;
/**
 * --
 * @desc Enumerates the possible invitation statuses the team member can have within a business.
 * --
 *
 * SOURCE InvitationStatus @ squareup/team_api/resources/datatypes.proto at 362:3
 */
TeamMember.InvitationStatus = $root.lookupEnum('squareup.team_api.TeamMember.InvitationStatus').values;
/**
 * --
 * @desc Enumerates the possible statuses the team member can have within a business.
 * --
 *
 * SOURCE Status @ squareup/team_api/resources/datatypes.proto at 394:3
 */
TeamMember.Status = $root.lookupEnum('squareup.team_api.TeamMember.Status').values;
/**
 * --
 * @desc Reasons for an employee's access to POS and Dashboard to be blocked
 * --
 * Original Design Doc: https://docs.google.com/document/d/1dFam0eNV8hrBb-lZGIk4rjY1OIn_Zd9dlboPXZIb5EQ/edit#heading=h.mfoxvr3ruaof
 *
 * SOURCE AccessBlocker @ squareup/team_api/resources/datatypes.proto at 413:3
 */
TeamMember.AccessBlocker = $root.lookupEnum('squareup.team_api.TeamMember.AccessBlocker').values;
/**
 * --
 * @desc An object that represents a team member's assignment to locations.
 * --
 *
 * SOURCE AssignedLocations @ squareup/team_api/resources/datatypes.proto at 434:3
 */
TeamMember.AssignedLocations = $root.lookupType('squareup.team_api.TeamMember.AssignedLocations');
fixType(TeamMember.AssignedLocations);
Builder.createAndAttachToType(TeamMember.AssignedLocations);
/**
 * --
 * @desc Enumerates the possible assignment types that the team member can have.
 * --
 *
 * SOURCE AssignmentType @ squareup/team_api/resources/datatypes.proto at 459:5
 */
TeamMember.AssignedLocations.AssignmentType = $root.lookupEnum('squareup.team_api.TeamMember.AssignedLocations.AssignmentType').values;
/**
 * --
 * @desc An object that represents a team member's association to various Square products
 * --
 *
 * SOURCE AssociatedProducts @ squareup/team_api/resources/datatypes.proto at 477:3
 */
TeamMember.AssociatedProducts = $root.lookupType('squareup.team_api.TeamMember.AssociatedProducts');
fixType(TeamMember.AssociatedProducts);
Builder.createAndAttachToType(TeamMember.AssociatedProducts);
/**
 * --
 * @desc An object that represents a team member's association to a specific Square product
 * --
 *
 * SOURCE AssociatedProduct @ squareup/team_api/resources/datatypes.proto at 499:5
 */
TeamMember.AssociatedProducts.AssociatedProduct = $root.lookupType('squareup.team_api.TeamMember.AssociatedProducts.AssociatedProduct');
fixType(TeamMember.AssociatedProducts.AssociatedProduct);
Builder.createAndAttachToType(TeamMember.AssociatedProducts.AssociatedProduct);
/**
 * --
 * @desc Enumerates the possible statuses that a specific product association to a team member can have.
 * --
 *
 * SOURCE AssociatedProductStatus @ squareup/team_api/resources/datatypes.proto at 520:7
 */
TeamMember.AssociatedProducts.AssociatedProduct.AssociatedProductStatus = $root.lookupEnum('squareup.team_api.TeamMember.AssociatedProducts.AssociatedProduct.AssociatedProductStatus').values;
/**
 * SOURCE TeamMemberFetchFieldScope @ squareup/team_api/resources/datatypes.proto at 554:1
 */
export const TeamMemberFetchFieldScope = {};
/**
 * SOURCE FetchField @ squareup/team_api/resources/datatypes.proto at 557:3
 */
TeamMemberFetchFieldScope.FetchField = $root.lookupEnum('squareup.team_api.TeamMemberFetchFieldScope.FetchField').values;
/**
 * --
 * @desc An object describing a badge assignment to a team member. A team member can have only one active
 * pairing at a time.
 * --
 *
 * SOURCE TeamMemberBadgePairing @ squareup/team_api/resources/datatypes.proto at 613:1
 */
export const TeamMemberBadgePairing = $root.lookupType('squareup.team_api.TeamMemberBadgePairing');
fixType(TeamMemberBadgePairing, {
  teamMemberId: {
    notEmpty: true
  },
  state: {
    required: true
  }
});
Builder.createAndAttachToType(TeamMemberBadgePairing);
/**
 * --
 * @desc Enumerates the possible states that a badge assignment can have with a team member.
 * --
 *
 * SOURCE State @ squareup/team_api/resources/datatypes.proto at 634:3
 */
TeamMemberBadgePairing.State = $root.lookupEnum('squareup.team_api.TeamMemberBadgePairing.State').values;
/**
 * --
 * @desc Represents a job that can be assigned to [team members](entity:TeamMember). This object defines the
 * job's title and tip eligibility. Compensation is defined in a [job assignment](entity:JobAssignment)
 * in a team member's wage setting.
 * --
 *
 * SOURCE Job @ squareup/team_api/resources/datatypes.proto at 656:1
 */
export const Job = $root.lookupType('squareup.team_api.Job');
fixType(Job);
Builder.createAndAttachToType(Job);
/**
 * --
 * @desc Represents information about the overtime exemption status, job assignments, and compensation
 * for a [team member](entity:TeamMember).
 * --
 *
 * SOURCE WageSetting @ squareup/team_api/resources/datatypes.proto at 703:1
 */
export const WageSetting = $root.lookupType('squareup.team_api.WageSetting');
fixType(WageSetting);
Builder.createAndAttachToType(WageSetting);
/**
 * --
 * @desc Represents a job assigned to a [team member](entity:TeamMember), including the compensation the team
 * member earns for the job. Job assignments are listed in the team member's [wage setting](entity:WageSetting).
 * --
 *
 * SOURCE JobAssignment @ squareup/team_api/resources/datatypes.proto at 746:1
 */
export const JobAssignment = $root.lookupType('squareup.team_api.JobAssignment');
fixType(JobAssignment, {
  payType: {
    required: true
  }
});
Builder.createAndAttachToType(JobAssignment);
/**
 * --
 * @desc Enumerates the possible pay types that a job can be assigned.
 * --
 *
 * SOURCE PayType @ squareup/team_api/resources/datatypes.proto at 785:3
 */
JobAssignment.PayType = $root.lookupEnum('squareup.team_api.JobAssignment.PayType').values;
/**
 * --
 * @desc Represents the type of contact method for Team member.
 * --
 *
 * SOURCE ContactMethodType @ squareup/team_api/resources/datatypes.proto at 808:1
 */
export const ContactMethodType = $root.lookupEnum('squareup.team_api.ContactMethodType').values;
/**
 * --
 * @desc An object describing an invitation sent to a team member. On acceptance, the team
 * member is fully provisioned and the setup is completed.
 * --
 *
 * SOURCE TeamMemberInvitation @ squareup/team_api/resources/datatypes.proto at 820:1
 */
export const TeamMemberInvitation = $root.lookupType('squareup.team_api.TeamMemberInvitation');
fixType(TeamMemberInvitation, {
  teamMemberId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(TeamMemberInvitation);
/**
 * SOURCE TeamMemberCashAppAccount @ squareup/team_api/resources/datatypes.proto at 881:1
 */
export const TeamMemberCashAppAccount = $root.lookupType('squareup.team_api.TeamMemberCashAppAccount');
fixType(TeamMemberCashAppAccount);
Builder.createAndAttachToType(TeamMemberCashAppAccount);
/**
 * SOURCE TeamMemberIncludes @ squareup/team_api/resources/datatypes.proto at 890:1
 */
export const TeamMemberIncludes = {};
/**
 * --
 * @desc Included resources that may be requested.
 * --
 *
 * SOURCE Include @ squareup/team_api/resources/datatypes.proto at 896:3
 */
TeamMemberIncludes.Include = $root.lookupEnum('squareup.team_api.TeamMemberIncludes.Include').values;
/**
 * SOURCE TeamMemberIncludedResources @ squareup/team_api/resources/datatypes.proto at 909:1
 */
export const TeamMemberIncludedResources = $root.lookupType('squareup.team_api.TeamMemberIncludedResources');
fixType(TeamMemberIncludedResources);
Builder.createAndAttachToType(TeamMemberIncludedResources);